import {
  Directive,
  Inject,
  Input,
  PLATFORM_ID,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({ selector: '[appBrowserOnly]', standalone: true })
export class BrowserOnlyDirective {
  private rendered = false;
  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    @Inject(PLATFORM_ID) private pid: Object,
  ) {}
  @Input() set appBrowserOnly(enabled: boolean) {
    const isBrowser = isPlatformBrowser(this.pid);
    if (enabled === false) {
      this.vcr.clear();
      this.rendered = false;
      return;
    }
    if (isBrowser && !this.rendered) {
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.rendered = true;
    } else if (!isBrowser) {
      this.vcr.clear();
      this.rendered = false;
    }
  }
}
